import type { ReactNode } from "react";
import { config } from "../lib/config";

function Frame({ status, children }: { status: string; children: ReactNode }) {
  return (
    <div className="fullscreen">
      <div className="boot-card reveal" data-d="1">
        <div className="bar">
          <span className="mark" />
          <span>DRAWBOARD PROJECTS · ADMIN CONSOLE</span>
          <span style={{ marginLeft: "auto" }}>{status}</span>
        </div>
        <div className="content">{children}</div>
      </div>
    </div>
  );
}

export function BootScreen({ line, status }: { line: string; status: string }) {
  return (
    <Frame status={status}>
      <h2>Stand by</h2>
      <p>{line}</p>
      <div className="scanline" />
      <div className="mono-block">
        <b>authority</b> &nbsp;{config.authority}
        <br />
        <b>client</b> &nbsp;&nbsp;&nbsp;{config.clientId}
        <br />
        <b>scope</b> &nbsp;&nbsp;&nbsp;&nbsp;openid profile email offline_access {config.adminScope}
      </div>
    </Frame>
  );
}

export function AccessDeniedScreen({ onSignOut }: { onSignOut: () => void }) {
  return (
    <Frame status="DENIED">
      <h2 style={{ color: "var(--amber)" }}>Not authorised</h2>
      <p>
        The identity server did not grant the <code className="mono">{config.adminScope}</code> scope to your account,
        so you are not a member of the <code className="mono">drawboard-admin</code> role. Ask an existing admin to add
        you, then sign in again.
      </p>
      <div className="btn-row" style={{ marginTop: 20 }}>
        <button className="btn" onClick={onSignOut}>
          <span className="glyph" /> Sign out
        </button>
      </div>
      <div className="mono-block">
        <b>environment</b> &nbsp;{config.environmentName}
      </div>
    </Frame>
  );
}

export function ErrorScreen({
  message,
  onRetry,
  onSignOut,
}: {
  message: string;
  onRetry: () => void;
  onSignOut: () => void;
}) {
  return (
    <Frame status="FAULT">
      <h2 style={{ color: "var(--red)" }}>Session error</h2>
      <p>Authentication could not be completed.</p>
      <div className="callout error" style={{ marginBottom: 18 }}>
        <span className="mk">err</span>
        <pre style={{ margin: 0 }}>{message}</pre>
      </div>
      <div className="btn-row">
        <button className="btn btn-primary" onClick={onRetry}>
          <span className="glyph" /> Retry sign-in
        </button>
        <button className="btn btn-ghost" onClick={onSignOut}>
          Clear session
        </button>
      </div>
    </Frame>
  );
}
